import React from 'react';
import { ProjectType } from 'nekst-api';

type ApplicationSettingsNavigationContextType = {
  openApplicationSettings: (projectType: ProjectType) => void,
}

const ApplicationSettingsNavigationReactContext = React.createContext<ApplicationSettingsNavigationContextType | null>(null);

export function useApplicationSettingsNavigationContextRequired(): ApplicationSettingsNavigationContextType {
  const context = React.useContext(ApplicationSettingsNavigationReactContext);
  if (!context) {
    throw new Error('useApplicationSettingsNavigationContext must be used within a ApplicationSettingsNavigationProvider');
  }
  return context;
}

export function ApplicationSettingsNavigationContext(props: {
  children: React.ReactNode,
  openApplicationSettingsFunc: () => void,
}) {
  return (
    <ApplicationSettingsNavigationReactContext.Provider value={{ openApplicationSettings: props.openApplicationSettingsFunc }}>
      {props.children}
    </ApplicationSettingsNavigationReactContext.Provider>
  )
}
